import { useState } from 'react'
import {
    getFromLocalStorage,
    removeFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { getConfigRepository } from '@/shared/getContainer/getConfigRepository'
import Config from '@/shared/config/config'
import { useAppStore, useTVStore, useVODStore } from '@/shared/store'
import { configLsKeyword } from '@/api/toya/apiConstantsCodespot'

const ConfigRepository = await getConfigRepository()
const configRepository = ConfigRepository.Instance

export const useAuthenticationConfig = () => {
    const token = getFromLocalStorage(sessionTokenLsKeyword)
    const [isTokenInStorage, setIsTokenInStorage] = useState(!!token)
    const { setAppSkin } = useAppStore()
    const { resetVODCache } = useVODStore()
    const { setChannelsData } = useTVStore()

    const getAndSaveAppSkinToStore = (config: Config | null | undefined) => {
        if (config) {
            const { skin } = config
            setAppSkin(skin)
        }
    }

    const takeConfigIfNeed = async () => {
        removeFromLocalStorage(configLsKeyword)
        await configRepository.takeConfigIfNeed()
        const config = configRepository.getLocalConfig()
        getAndSaveAppSkinToStore(config)
        if (config) {
            setChannelsData([])
            resetVODCache()
        }
    }

    const getToken = () => {
        if (token) {
            setIsTokenInStorage(true)
        }
    }
    const authenticateAndFetchConfig = async () => {
        if (!isTokenInStorage) {
            getToken()
        }
        await takeConfigIfNeed()
    }

    return { authenticateAndFetchConfig }
}
